// Вкладки карточки заявки, перенесённые из старого Office (dict/client-request-detail-list и dict/remont-edit).
// Право-вкладка (admin.grant_tab под OA__RemontFormTabulation, бэк: office_api/office_port/areas/requests/TAB_GRANTS)
// → имя компонента → ленивый компонент → группа в меню «Ещё». Сами списки — в request.js (вкладки заявки)
// и remont.js (вкладки ремонта), здесь только сборка.
import * as request from "./request";
import * as remont from "./remont";
import * as requestRead from "./requestRead";
import * as credit from "./credit";

const parts = [request, requestRead, remont, credit];

// grant_code → имя компонента (подмешивается в tabsCodes, services/index.js)
export const officeTabsCodes = Object.assign({}, ...parts.map((p) => p.tabsCodes || {}));
// имя компонента → компонент (регистрируется в ClientRequests/index.vue)
export const officeTabComponents = Object.assign({}, ...parts.map((p) => p.components || {}));
// ключ группы TAB_GROUPS → [имена компонентов] (дописываются в конец группы, tabGroups.js)
export const officeTabGroups = parts.reduce((acc, p) => {
  Object.entries(p.groups || {}).forEach(([key, tabs]) => {
    acc[key] = [...(acc[key] || []), ...tabs];
  });
  return acc;
}, {});
// синонимы для поиска в «Ещё»
export const officeTabAliases = Object.assign({}, ...parts.map((p) => p.aliases || {}));
